import React from 'react';
import { DataTableColumn } from '../../Base/Components/DataTable/DataTable';
import { QueryDataItem } from '../../../Interfaces/QueryDataItem';
import {
	CreateInvoiceInsuranceCompanyBatchMutation,
	InsuranceCompanyBatchesQuery,
} from '../../../graphql/graphql';
import ManagerInsuranceCompaniesBatchDownload from '../Components/ManagerWrapper/InsuranceCompanies/ManagerInsuranceCompaniesBatchesList/ManagerInsuranceCompaniesBatchDownload';
import ManagerInsuranceCompaniesBatchInvoiceAction from '../Components/ManagerWrapper/InsuranceCompanies/ManagerInsuranceCompaniesBatchInvoice/ManagerInsuranceCompaniesBatchInvoiceAction';
import ManagerInsuranceCompaniesBatchStatusBadge from '../Components/ManagerWrapper/InsuranceCompanies/ManagerInsuranceCompaniesBatchStatus/ManagerInsuranceCompaniesBatchStatusBadge';
import { resolveInvoiceBatchDisplayStatus } from './InsuranceCompanyBatchStatus.const';
import FormattedDate from '../../../Components/FormattedDate';

export type InsuranceCompanyBatch = QueryDataItem<
	InsuranceCompanyBatchesQuery['insuranceCompanyBatches']
>;

export type InvoiceBatch =
	CreateInvoiceInsuranceCompanyBatchMutation['createInvoiceInsuranceCompanyBatch'];

export interface InsuranceCompanyBatchesTable {
	onInvoiceCreated?: (batchId: string, invoiceBatch: InvoiceBatch) => void;
}

export const InsuranceCompanyBatchesDefaultColumns: DataTableColumn<
	InsuranceCompanyBatch,
	InsuranceCompanyBatchesTable
>[] = [
	{
		key: 'dcid',
		label: 'component.insuranceCompanyBatch.table.dcid',
		bold: true,
		renderItem: item => item.dcid,
	},
	{
		key: 'dtyp',
		label: 'component.insuranceCompanyBatch.table.dtyp',
		renderItem: item => item.dtyp,
	},
	{
		key: 'insuranceCompanyCode',
		label: 'component.insuranceCompanyBatch.table.insuranceCompanyCode',
		renderItem: item => item.insuranceCompanyCode,
	},
	{
		key: 'periodMonth',
		label: 'component.insuranceCompanyBatch.table.periodMonth',
		renderItem: item => item.periodMonth,
	},
	{
		key: 'periodYear',
		label: 'component.insuranceCompanyBatch.table.periodYear',
		renderItem: item => item.periodYear,
	},
	{
		key: 'createdAt',
		label: 'component.insuranceCompanyBatch.table.createdAt',
		renderItem: item => <FormattedDate date={item.createdAt} />,
	},
	{
		key: 'batchStatus',
		label: 'component.insuranceCompanyBatch.table.batchStatus',
		renderItem: item =>
			item.batchStatus ? (
				<ManagerInsuranceCompaniesBatchStatusBadge status={item.batchStatus} />
			) : undefined,
	},
	{
		key: 'invoiceStatus',
		label: 'component.insuranceCompanyBatch.table.invoiceStatus',
		renderItem: item => {
			const status = resolveInvoiceBatchDisplayStatus(item);

			return status ? (
				<ManagerInsuranceCompaniesBatchStatusBadge status={status} />
			) : undefined;
		},
	},
	{
		key: 'downloadFile',
		label: 'component.insuranceCompanyBatch.table.downloadFile',
		renderItem: item => (
			<ManagerInsuranceCompaniesBatchDownload file={item.file} />
		),
	},
	{
		key: 'invoice',
		label: 'component.insuranceCompanyBatch.table.invoice',
		renderItem: (item, table) => (
			<ManagerInsuranceCompaniesBatchInvoiceAction
				batch={item}
				onInvoiceCreated={invoiceBatch =>
					table?.onInvoiceCreated?.(item.id, invoiceBatch)
				}
			/>
		),
	},
];
